import { SelectionFilter, SelectionFilterType } from '@api/twin/SelectionFilterApi';
import AdvancedSearchIcon from '@resources/icons/AdvancedSearchIcon.svg?react';
import SelectionInfoIcon from '@resources/icons/SelectionInfoIcon.svg?react';
import { Box } from '@stereograph/teia-system-design/components/Box';
import { MRT_Row } from '@stereograph/teia-system-design/components/Table';
import { Tooltip } from '@stereograph/teia-system-design/components/Tooltip';
import { usePluginTranslation } from '@translation';
import { Icon } from '@stereograph/teia-system-design/components/Icon';

interface SelectionTypeCellProps {
  row: MRT_Row<SelectionFilter>;
}

export const SelectionTypeCell = (props: SelectionTypeCellProps) => {
  const { row } = props;
  const { t } = usePluginTranslation();
  const isStaticFilter = row.original.type === SelectionFilterType.STATIC;
  const tooltipContent = isStaticFilter
    ? t('selection_plugin.record_widget.selection_list.static_filter.tooltip')
    : t('selection_plugin.record_widget.selection_list.dynamic_filter.tooltip');

  return (
    <Box sx={{
      display: 'inline-block',
    }}
    >
      <Tooltip title={tooltipContent}>
        <Icon
          component={isStaticFilter ? SelectionInfoIcon : AdvancedSearchIcon}
          fontSize="small"
        />
      </Tooltip>
    </Box>
  );
};
